import { render, staticRenderFns } from "./Report-services.vue?vue&type=template&id=1c0879e7&scoped=true"
import script from "./Report-services.vue?vue&type=script&lang=js"
export * from "./Report-services.vue?vue&type=script&lang=js"
import style0 from "./Report-services.vue?vue&type=style&index=0&id=1c0879e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0879e7",
  null
  
)

export default component.exports